import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableContainer,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
  Select,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaEdit, FaEye, FaLayerGroup, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { BLUEMONEDDBUTTONS, VARIANT, WHITE } from "../../../../constants/colors";
import Pagination from "../../../../defaultComponents/pagination";
import {
  SuportSolicitationList,
} from "../../../../interfaces/defaultInterfaces";
import { HamburgerIcon } from "@chakra-ui/icons";
import SuportSolicitationsAPI from "../../../../services/servicosSolicitacoesApi";
import ModalVisualizacao from "./ModalVisualização";
import ModalTrocaStatus from "./ModalTrocaStatus";
import moment from "moment";
import { dateForList } from "../../../../constants/dataFormat";

export default function TableSuportSolicitation({
  search,
  dataInicio,
  dataFim,
  idCliente,
  status,
  tipoServico,
}: any) {
  const [suportList, setsuportList] = useState(Array<SuportSolicitationList>);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const refreshGloabl = useRecoilState(refreshGlobal)[0];
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [idModalVisualizar, setIdModalVisualizar] = useState({});

  async function getFornecedoresList() {
    try {
      const res = await SuportSolicitationsAPI.getSuporteList(
        currentPage,
        pageSize,
        dataInicio,
        dataFim,
        status,
        idCliente,
        tipoServico
      );

      setsuportList(res.data);
      setPages(Math.ceil(Number(res.headers.totalamountofrecords) / pageSize));
    } catch (error) {
      console.log(error);
    }
  }

  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getFornecedoresList();
    }
  }, [pages]);
  useEffect(() => {
    if(idCliente !== 0){
      getFornecedoresList();
    }
  }, [
    refreshGloabl,
    search,
    currentPage,
    pageSize,
    dataInicio,
    dataFim,
    idCliente,
    status,
    tipoServico,
  ]);

  const [openModalVisualizacao, setOpenModalVisualizacao] = useState(false);
  const [openModalTrocaStatus, setOpenModalTrocaStatus] = useState(false);

  return (
    <>
      <TableContainer>
        <Table variant="striped" colorScheme='gray' size="sm" overflowY="scroll">
          <Thead h="60px" position="sticky" top="0">
            <Tr>
              {/* <Th bgColor={VARIANT} color={WHITE}>
                Data
              </Th> */}
              <Th borderRadius={"8px 0 0 8px"} bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                Cliente
              </Th>
              <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                Tipo
              </Th>
              <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                Bobinas/POS
              </Th>
              <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                Observações
              </Th>
              <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                Situação
              </Th>
              <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                Data
              </Th>
              <Th borderRadius={"0 8px 8px 0"} bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                Opções
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {suportList &&
              suportList.map((item, index) => {
                return (
                  <Tr key={index}>
                    {/* <Td>{item.}</Td> */}
                    <Td>
                      {item.cliente?.isCnpj === true
                        ? item.cliente?.razaoSocial
                        : `${item.cliente?.nome} ${item.cliente?.sobrenome}`}
                    </Td>
                    <Td>{item.tipoServico?.servico}</Td>
                    <Td>{item.idTipoServico === 1 ? item.qtdBobinas : "N/A"}</Td>
                    <Td whiteSpace={"normal"}>{item.observacao}</Td>
                    <Td>{item.servicoStatus.situacao}</Td>
                    <Td>{moment(item.data).format(dateForList)}</Td>
                    <Td width={"400px"} whiteSpace={"normal"}>
                      <Menu>
                        <MenuButton
                          as={IconButton}
                          aria-label="Options"
                          icon={<HamburgerIcon />}
                          bgColor={BLUEMONEDDBUTTONS}
                          color={WHITE}
                          size={"sm"}
                        />
                        <MenuList>
                          <MenuItem
                            onClick={() => {
                              setOpenModalVisualizacao(true);
                              setIdModalVisualizar(item.id);
                            }}
                            icon={<FaEye />}
                          >
                            Visualizar
                          </MenuItem>
                          {item.servicoStatus.situacao.toLowerCase() !=
                            "finalizado" && item.servicoStatus.situacao.toLowerCase() !=
                            "cancelado" &&(
                            <MenuItem
                              icon={<FaLayerGroup />}
                              onClick={() => {
                                setOpenModalTrocaStatus(true);
                                setIdModalVisualizar(item);
                              }}
                            >
                              Atualizar Solicitação
                            </MenuItem>
                          )}
                        </MenuList>
                      </Menu>
                    </Td>
                  </Tr>
                );
              })}
          </Tbody>
        </Table>
      </TableContainer>

      <Flex width={"100%"} justifyContent="center" mt={8}>
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pages={pages}
          pageSize={pageSize}
        />
        <Select
          value={pageSize}
          onChange={onChangeSize}
          size="sm"
          ml={5}
          maxW="70px"
          borderRadius="6px"
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
        </Select>
      </Flex>

      <ModalVisualizacao
        isOpen={openModalVisualizacao}
        setIsOpen={setOpenModalVisualizacao}
        id={idModalVisualizar}
      />
      <ModalTrocaStatus
        isOpen={openModalTrocaStatus}
        setIsOpen={setOpenModalTrocaStatus}
        item={idModalVisualizar}
      />
    </>
  );
}
